// extracted by mini-css-extract-plugin
module.exports = {"root":"AboutMe_root__FwV6Y","card":"AboutMe_card__2rjjP"};